(function () {
  var desktopQuery = window.matchMedia('(min-width: 750px)');
  if (!desktopQuery.matches) return;

  var style = document.createElement('style');
  style.textContent = `
    button[data-testid="cart-drawer-trigger"],
    .header-actions__action.action__cart,
    cart-icon.header-actions__cart-icon {
      display: none !important;
    }

    .header-menu,
    .dropdown-localization {
      display: none !important;
    }

    .pf-nav {
      display: flex;
      align-items: center;
      gap: 8px;
      height: 100%;
      flex: 1;
      min-width: 0;
    }

    .pf-nav__dropdown {
      position: relative;
      flex-shrink: 0;
    }

    .pf-nav__btn {
      background: none;
      border: none;
      color: inherit;
      font-family: inherit;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      gap: 4px;
      min-height: 44px;
      transition: background 0.15s;
      white-space: nowrap;
    }

    .pf-nav__btn:hover {
      background: rgba(255,255,255,0.1);
    }

    .pf-nav__btn svg {
      width: 12px;
      height: 12px;
      transition: transform 0.2s;
      flex-shrink: 0;
    }

    .pf-nav__dropdown.open .pf-nav__btn svg {
      transform: rotate(180deg);
    }

    .pf-nav__panel,
    .pf-mega {
      display: none !important;
      position: absolute;
      top: calc(100% + 8px);
      left: 0;
      background: #fff;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      box-shadow: 0 8px 24px rgba(7,19,48,0.12);
      z-index: 99999;
      color: #0b1838;
    }

    .pf-nav__dropdown.open .pf-nav__panel {
      display: block !important;
      min-width: 220px;
      padding: 8px 0;
    }

    .pf-nav__dropdown.open .pf-mega {
      display: grid !important;
      grid-template-columns: repeat(3, 1fr);
      gap: 16px;
      padding: 20px;
      width: 560px;
    }

    .pf-mega__group-title {
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #6b7280;
      padding-bottom: 6px;
      border-bottom: 1px solid #f0f0f0;
      margin-bottom: 6px;
      margin-top: 0;
    }

    .pf-mega__group ul {
      list-style: none !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .pf-mega__group ul li {
      list-style: none !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .pf-mega__group ul li a {
      display: block;
      padding: 5px 0;
      font-size: 13px;
      color: #0b1838 !important;
      text-decoration: none !important;
      transition: color 0.15s;
    }

    .pf-mega__group ul li a:hover {
      color: #1b7fe5 !important;
    }

    .pf-locations__list {
      list-style: none !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .pf-locations__list li {
      list-style: none !important;
    }

    .pf-locations__list li a {
      display: block;
      padding: 9px 16px;
      font-size: 13px;
      color: #0b1838 !important;
      text-decoration: none !important;
      transition: background 0.15s;
    }

    .pf-locations__list li a:hover {
      background: #f5f7fa;
      color: #1b7fe5 !important;
    }

    .pf-spacer {
      flex: 1;
    }

    .pf-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
    }

    .pf-actions__login {
      background: none !important;
      border: 1px solid rgba(255,255,255,0.4) !important;
      color: inherit !important;
      font-size: 13px;
      font-weight: 500;
      padding: 0 16px;
      height: 36px;
      border-radius: 6px;
      cursor: pointer;
      text-decoration: none !important;
      display: flex;
      align-items: center;
      transition: border-color 0.15s, background 0.15s;
      white-space: nowrap;
    }

    .pf-actions__login:hover {
      border-color: rgba(255,255,255,0.7) !important;
      background: rgba(255,255,255,0.1) !important;
    }

    .pf-actions__list {
      background: #1b7fe5 !important;
      color: #fff !important;
      font-size: 13px;
      font-weight: 600;
      padding: 0 16px;
      height: 36px;
      border-radius: 6px;
      cursor: pointer;
      text-decoration: none !important;
      display: flex;
      align-items: center;
      transition: background 0.15s;
      border: none !important;
      white-space: nowrap;
    }

    .pf-actions__list:hover {
      background: #1570cc !important;
    }
  `;
  document.head.appendChild(style);

  function initProFindNav() {
    var header = document.querySelector('.header__columns');
    if (!header) return;
    if (document.getElementById('pf-nav-root')) return;

    var logoCol = header.querySelector('.header__column--left');
    if (!logoCol) return;

    var nav = document.createElement('div');
    nav.className = 'pf-nav';
    nav.id = 'pf-nav-root';
    nav.innerHTML = `
      <div class="pf-nav__dropdown" id="pf-categories">
        <button class="pf-nav__btn" aria-expanded="false" type="button">
          Categories
          <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 4l4 4 4-4"/></svg>
        </button>
        <div class="pf-mega" role="menu">
          <div class="pf-mega__group">
            <div class="pf-mega__group-title">Home &amp; Property</div>
            <ul>
              <li><a href="/pages/find-a-pro?service=plumbers">Plumbers</a></li>
              <li><a href="/pages/find-a-pro?service=electricians">Electricians</a></li>
              <li><a href="/pages/find-a-pro?service=builders">Builders</a></li>
              <li><a href="/pages/find-a-pro?service=painters">Painters</a></li>
              <li><a href="/pages/find-a-pro?service=cleaning">Cleaning</a></li>
              <li><a href="/pages/find-a-pro?service=garden-services">Garden Services</a></li>
            </ul>
          </div>
          <div class="pf-mega__group">
            <div class="pf-mega__group-title">Events</div>
            <ul>
              <li><a href="/pages/find-a-pro?service=photographers">Photographers</a></li>
              <li><a href="/pages/find-a-pro?service=catering">Catering</a></li>
              <li><a href="/pages/find-a-pro?service=djs">DJs</a></li>
              <li><a href="/pages/find-a-pro?service=decor">Decor</a></li>
            </ul>
            <div class="pf-mega__group-title" style="margin-top:12px">Automotive</div>
            <ul>
              <li><a href="/pages/find-a-pro?service=mechanics">Mechanics</a></li>
              <li><a href="/pages/find-a-pro?service=panel-beaters">Panel Beaters</a></li>
              <li><a href="/pages/find-a-pro?service=car-detailing">Car Detailing</a></li>
            </ul>
          </div>
          <div class="pf-mega__group">
            <div class="pf-mega__group-title">Personal</div>
            <ul>
              <li><a href="/pages/find-a-pro?service=beauty">Beauty</a></li>
              <li><a href="/pages/find-a-pro?service=hair">Hair</a></li>
              <li><a href="/pages/find-a-pro?service=fitness">Fitness</a></li>
              <li><a href="/pages/find-a-pro?service=tutors">Tutors</a></li>
            </ul>
            <div class="pf-mega__group-title" style="margin-top:12px">Business</div>
            <ul>
              <li><a href="/pages/find-a-pro?service=accountants">Accountants</a></li>
              <li><a href="/pages/find-a-pro?service=web-design">Web Design</a></li>
              <li><a href="/pages/find-a-pro?service=marketing">Marketing</a></li>
              <li><a href="/pages/find-a-pro?service=it-services">IT Services</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="pf-nav__dropdown" id="pf-locations">
        <button class="pf-nav__btn" aria-expanded="false" type="button">
          Locations
          <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 4l4 4 4-4"/></svg>
        </button>
        <div class="pf-nav__panel" role="menu">
          <ul class="pf-locations__list">
            <li><a href="/pages/find-a-pro?location=gauteng">Gauteng</a></li>
            <li><a href="/pages/find-a-pro?location=western-cape">Western Cape</a></li>
            <li><a href="/pages/find-a-pro?location=kwazulu-natal">KwaZulu-Natal</a></li>
            <li><a href="/pages/find-a-pro?location=eastern-cape">Eastern Cape</a></li>
            <li><a href="/pages/find-a-pro?location=free-state">Free State</a></li>
            <li><a href="/pages/find-a-pro?location=limpopo">Limpopo</a></li>
            <li><a href="/pages/find-a-pro?location=mpumalanga">Mpumalanga</a></li>
            <li><a href="/pages/find-a-pro?location=north-west">North West</a></li>
            <li><a href="/pages/find-a-pro?location=northern-cape">Northern Cape</a></li>
          </ul>
        </div>
      </div>

      <div class="pf-spacer"></div>

      <div class="pf-actions">
        <a href="/pages/login" class="pf-actions__login">Log In</a>
        <a href="/pages/list-your-business" class="pf-actions__list">List Your Business</a>
      </div>
    `;

    logoCol.after(nav);

    nav.querySelectorAll('.pf-nav__dropdown').forEach(function(dropdown) {
      var btn = dropdown.querySelector('.pf-nav__btn');
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = dropdown.classList.contains('open');
        nav.querySelectorAll('.pf-nav__dropdown.open').forEach(function(d) {
          d.classList.remove('open');
          d.querySelector('.pf-nav__btn').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          dropdown.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function() {
      nav.querySelectorAll('.pf-nav__dropdown.open').forEach(function(d) {
        d.classList.remove('open');
        d.querySelector('.pf-nav__btn').setAttribute('aria-expanded', 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProFindNav);
  } else {
    initProFindNav();
  }
})();
